<template>
    <div class="buttons">
        <div class="forca">
        <h1>Esc<img src="/jogo-da-forca/images/brain.png" />lha o tema</h1>
    </div>
        <button @click="song" id="buttonClick" class="tec" v-on:click="EscolherTipo1" value="tecnologia">Tecnologia</button>
        <button @click="song" id="buttonClick" class="pro" v-on:click="EscolherTipo2" value="profissao">Profissões</button>
        <button @click="song" id="buttonClick" class="ani" v-on:click="EscolherTipo3" value="animais">Animais</button>
        <button @click="song" id="buttonClick" class="obj" v-on:click="EscolherTipo4" value="objetos">Objetos</button>
    </div> 
</template>

<script>

export default {
    name:'Escolher',
    components:{
    },
    props:{
        actionChoiceValues: Function
    },

    methods:{
        song(){
            var click = new Audio('./songs/click.mp3');
            click.play();
        },
        
        EscolherTipo1(){
            var value = document.querySelector(".tec").value
            this.actionChoiceValues(value);
        },
        EscolherTipo2(){
          
            var value = document.querySelector(".pro").value
            this.actionChoiceValues(value);
        },
        EscolherTipo3(){
            var value = document.querySelector(".ani").value
            this.actionChoiceValues(value);
        },
        EscolherTipo4(){

            var value = document.querySelector(".obj").value
            this.actionChoiceValues(value);
        },

        
    }
}
</script>

<style scoped>
.buttons{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    }

#buttonClick{
    display: block;
    margin:6px 0;
    overflow: hidden;
    position: relative;
    z-index: 0;
    font-size: 20px;
    cursor:pointer;
    width: 400px;
    padding: 18px 0;
    outline: none;
    background: linear-gradient(20deg,rgba(0, 0, 0, 0.219),rgb(4, 15, 19));
}

#buttonClick::before{
    content:'';
    position: absolute;
     top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    clip-path: polygon(0 0, 100% 0, 0 0, 0% 100%);
    background: linear-gradient(10deg,rgba(42, 177, 231, 0.945),rgba(73, 20, 219, 0.835));
    transition:.3s linear;
}
.imagem{
    width:40px;
    text-align: center;
    padding-right: 5px;
}
#buttonClick:hover::before{
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
}

.imagem{
    width:50px;
}
.forca{
      animation:animar infinite 3s alternate-reverse;
}
@keyframes animar{
    to{
        transform: scale(1);
    }from{
        transform: scale(0.8);
    }
}
.forca{
    display:flex;
    align-items: center;
    justify-content: center;
}
h1{
    display:flex;
    align-items: center;
    padding:9px 0;
    font-weight: bold;
    font-size: 41px;
    display:flex;
    align-items: center;
    text-shadow:rgba(10, 156, 214,0.5);
    color:rgb(81, 203, 251);
    letter-spacing: 5px;
}
    @media (max-width:450px){
     h1{
         font-size: 28px; 
     }

    .forca{     
        position:relative;
        top:15px;
     }
     
    }

@media (max-width:450px){
    #buttonClick{
        width:280px;
    }
}
</style>
